import React, { useState, useEffect } from "react";
import VacanciesImg from '../Images/Vacancies.jpg';
import UrlTag from "../components/UrlTag";
import { Link } from "react-router-dom";

function Vacancies() {
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const redirectToHome = () => {
        setIsSubmitted(false);
        setIsLoading(false);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        try {
            const formData = new FormData(event.target);
            const response = await fetch(
                'https://docs.google.com/forms/d/e/1FAIpQLSeVSZ76IODdnmCNchvNvhYmO-A-RODmdGFxGWPOgBSBRhtT9g/formResponse',
                {
                    method: 'POST',
                    body: formData,
                    mode: 'no-cors'
                }
            );
            console.log(response);
            setIsSubmitted(true);
        } catch (error) {
            console.error('Error submitting form:', error);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="z-20">
            <UrlTag />
            <div className="relative">
                <img src={VacanciesImg} alt="Vacancies" className="w-full h-[300px] md:h-[500px] object-cover" />
                <div className="absolute inset-0 bg-black opacity-40"></div>
                <div className="absolute bottom-0 left-0 py-4 sm:py-6 md:py-8 px-4 sm:px-6 md:px-8 lg:px-14">
                    <h1 className="text-white text-3xl sm:text-4xl font-bold">Vacancies</h1>
                </div>
            </div>
            <div className="p-4 sm:p-8 md:p-16 max-w-[620px] mx-auto">
                <div className="mb-10">
                    <h1 className="text-3xl text-gray-700 mb-3">We welcome the best talent</h1>
                    <div className="border mb-4 border-gray-200" />
                    <p className="text-lg mb-6 tracking-wider text-gray-700 font-light">
                        Architetive Designs is a dynamic, multidisciplinary practice driven by innovation and collaboration. Our work is underpinned by a sustainable approach to design and engineering.
                    </p>
                    <p className="text-lg mb-6 tracking-wider text-gray-700 font-light">
                        We are committed to supporting diversity and inclusivity and strive to create a working environment that is responsive to different cultures.
                    </p>
                    <p className="text-lg mb-6 tracking-wider text-gray-700 font-light">
                        We value the contributions of our diverse team and are proud to offer equal opportunities for all, regardless of age, disability, gender, marriage and civil partnership, race, religion or belief, sex and sexual orientation.
                    </p>
                </div>

                {/* Application Form Section */}
                <div className="mt-8 mb-8 bg-[#f5f5f5] p-5 rounded-lg">
                    {!isSubmitted ? (
                        <>
                            <h2 className="text-3xl text-gray-700 mb-6">Apply Now</h2>
                            <form onSubmit={handleSubmit} className="space-y-4">
                                <div className="grid grid-cols-1 gap-4">
                                    <div>
                                        <label className="block text-gray-700 mb-2">Full Name <span className="text-red-500">*</span></label>
                                        <input
                                            type="text"
                                            name="entry.1497008582"
                                            required
                                            className="w-full p-2 border border-gray-300 rounded-lg"
                                        />
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-gray-700 mb-2">Email</label>
                                        <input
                                            type="email"
                                            name="entry.1380085929"
                                            className="w-full p-2 border border-gray-300 rounded-lg"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-gray-700 mb-2">Phone Number <span className="text-red-500">*</span></label>
                                        <input
                                            required
                                            type="tel"
                                            name="entry.220177048"
                                            className="w-full p-2 border border-gray-300 rounded-lg"
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label className="block text-gray-700 mb-2">Position Applied For <span className="text-red-500">*</span></label>
                                    <select
                                        name="entry.772986331"
                                        required
                                        className="w-full p-2 border border-gray-300 rounded-lg bg-white"
                                    >
                                        <option value="">Select a position</option>
                                        <option value="architect">Architect</option>
                                        <option value="interior-designer">Interior Designer</option>
                                        <option value="project-manager">Project Manager</option>
                                        <option value="structural-engineer">Structural Engineer</option>
                                    </select>
                                </div>

                                <div>
                                    <label className="block text-gray-700 mb-2">Years of Experience <span className="text-red-500">*</span></label>
                                    <input
                                        type="number"
                                        name="entry.2098566886"
                                        required
                                        min="0"
                                        max="50"
                                        className="w-full p-2 border border-gray-300 rounded-lg"
                                    />
                                </div>

                                <div>
                                    <label className="block text-gray-700 mb-2">Cover Letter</label>
                                    <textarea
                                        name="entry.1415577050"
                                        rows="4"
                                        className="w-full p-2 border border-gray-300 rounded-lg"
                                    />
                                </div>

                                <div className="mt-6 flex justify-center">
                                    <button
                                        type="submit"
                                        disabled={isLoading}
                                        className="rounded-lg w-full md:w-auto px-8 py-2 bg-gray-700 text-white hover:bg-gray-600 disabled:bg-gray-400"
                                    >
                                        {isLoading ? 'Submitting...' : 'Submit Application'}
                                    </button>
                                </div>
                            </form>
                        </>
                    ) : (
                        <div className="p-8 text-center flex flex-col items-center justify-center">
                            <div className="mb-6">
                                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                    <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                                    </svg>
                                </div>
                                <h2 className="text-2xl font-bold text-gray- 900 mb-2">Thank You for Reaching Out!</h2>
                                <p className="text-gray-600 text-sm">
                                    We have received your request and appreciate you contacting us. Our team will get back to you shortly.
                                </p>
                            </div>
                            <button
                                onClick={redirectToHome}
                                className="bg-[#333333] text-white py-2 px-6 rounded-full hover:opacity-90 transition-colors"
                            >
                                Close
                            </button>
                        </div>
                    )}
                </div>

                <div>
                    <h1 className="text-xl mb-4 text-gray-500">Explore</h1>
                    <div className="flex-row space-y-4 mb-8">
                        <div className="space-x-4">
                            <Link to='/careers/early-careers'>
                                <button className="text-gray-600 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Early Careers</button>
                            </Link>
                            <Link to='/careers/benefits'>
                                <button className="text-gray-600 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Benefits</button>
                            </Link>
                        </div>
                        <div>
                            <Link to='/people/equity-diversity-and-inclusion'>
                                <button className="text-gray-600 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Equity, Diversity and Inclusion</button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Vacancies;




// import React, { useState, useEffect } from "react";
// import VacanciesImg from '../Images/Vacancies.jpg';
// import UrlTag from "../components/UrlTag";
// import { Link } from "react-router-dom";

// function Vacancies() {
//     const [isSubmitted, setIsSubmitted] = useState(false);
//     const [isLoading, setIsLoading] = useState(false);

//     const redirectToHome = () => {
//         setIsSubmitted(false);
//         setIsLoading(false);
//     };

//     const handleSubmit = async (event) => {
//         event.preventDefault();
//         setIsLoading(true);

//         try {
//             // Convert file to Base64
//             const fileInput = event.target.resume;
//             const file = fileInput.files[0];
//             const base64File = await convertToBase64(file);

//             // Get form data
//             const formData = new FormData(event.target);

//             // Create payload for Google Sheets
//             const payload = {
//                 name: formData.get("fullName"),
//                 email: formData.get("email"),
//                 phone: formData.get("phoneNumber"),
//                 position: formData.get("position"),
//                 experience: formData.get("experience"),
//                 coverLetter: formData.get("coverLetter"),
//                 resumeData: base64File,
//                 fileName: file.name,
//                 timestamp: new Date().toISOString()
//             };

//             console.log('Payload:', payload);

//             // Send to Google Apps Script endpoint
//             const response = await fetch(
//                 'https://script.google.com/macros/s/AKfycbyU9baz3IkZeIJ5Nv_fs9SYmlxDbAGi9WDwXQwwWHXTxxdnbD9x3c561U4Yr1eeSo46kg/exec',
//                 {
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json',
//                     },
//                     body: JSON.stringify(payload),
//                     mode: 'no-cors'
//                 }
//             );

//             console.log('Response:', response);

//             if (!response.ok) {
//                 throw new Error('Submission failed');
//             }

//             setIsSubmitted(true);
//         } catch (error) {
//             console.error('Error submitting form:', error.message);
//             alert('There was an error submitting your application. Please try again.');
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     // Function to convert file to Base64
//     const convertToBase64 = (file) => {
//         return new Promise((resolve, reject) => {
//             const reader = new FileReader();
//             reader.onload = () => resolve(reader.result.split(',')[1]);
//             reader.onerror = reject;
//             reader.readAsDataURL(file);
//         });
//     };

//     useEffect(() => {
//         window.scrollTo(0, 0);
//     }, []);

//     // Rest of the component remains the same
//     return (
//         <div className="z-20">
//             <UrlTag />
//             <div className="relative">
//                 <img src={VacanciesImg} alt="Vacancies" className="w-full h-[300px] md:h-[500px] object-cover" />
//                 <div className="absolute inset-0 bg-black opacity-50"></div>
//                 <div className="absolute bottom-0 left-0 py-4 sm:py-6 md:py-8 px-4 sm:px-6 md:px-8 lg:px-14">
//                     <h1 className="text-white text-3xl sm:text-4xl font-bold">Vacancies</h1>
//                 </div>
//             </div>
//             <div className="p-4 sm:p-8 md:p-16 max-w-[620px] mx-auto">
//                 <div className="mb-10">
//                     <h1 className="text-3xl text-gray-700 mb-3">We welcome the best talent</h1>
//                     <div className="border mb-4 border-gray-200" />
//                     <p className="text-lg mb-6 tracking-wider text-gray-700 font-light">
//                         Architetive Designs is a dynamic, multidisciplinary practice driven by innovation and collaboration. Our work is underpinned by a sustainable approach to design and engineering.
//                     </p>
//                     <p className="text-lg mb-6 tracking-wider text-gray-700 font-light">
//                         We are committed to supporting diversity and inclusivity and strive to create a working environment that is responsive to different cultures.
//                     </p>
//                     <p className="text-lg mb-6 tracking-wider text-gray-700 font-light">
//                         We value the contributions of our diverse team and are proud to offer equal opportunities for all, regardless of age, disability, gender, marriage and civil partnership, race, religion or belief, sex and sexual orientation.
//                     </p>
//                 </div>

//                 {/* Application Form Section */}
//                 <div className="mt-8 mb-8 bg-[#f5f5f5] p-5 rounded-lg">
//                     {!isSubmitted ? (
//                         <>
//                             <h2 className="text-3xl text-gray-700 mb-6">Apply Now</h2>
//                             <form onSubmit={handleSubmit} className="space-y-4">
//                                 <div className="grid grid-cols-1 gap-4">
//                                     <div>
//                                         <label className="block text-gray-700 mb-2">Full Name <span className="text-red-500">*</span></label>
//                                         <input
//                                             type="text"
//                                             name="fullName"
//                                             required
//                                             className="w-full p-2 border border-gray-300 rounded-lg"
//                                         />
//                                     </div>
//                                 </div>

//                                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                                     <div>
//                                         <label className="block text-gray-700 mb-2">Email</label>
//                                         <input
//                                             type="email"
//                                             name="email"
//                                             className="w-full p-2 border border-gray-300 rounded-lg"
//                                         />
//                                     </div>
//                                     <div>
//                                         <label className="block text-gray-700 mb-2">Phone Number <span className="text-red-500">*</span></label>
//                                         <input
//                                             required
//                                             type="tel"
//                                             name="phoneNumber"
//                                             className="w-full p-2 border border-gray-300 rounded-lg"
//                                         />
//                                     </div>
//                                 </div>

//                                 <div>
//                                     <label className="block text-gray-700 mb-2">Position Applied For <span className="text-red-500">*</span></label>
//                                     <select
//                                         name="position"
//                                         required
//                                         className="w-full p-2 border border-gray-300 rounded-lg bg-white"
//                                     >
//                                         <option value="">Select a position</option>
//                                         <option value="architect">Architect</option>
//                                         <option value="interior-designer">Interior Designer</option>
//                                         <option value="project-manager">Project Manager</option>
//                                         <option value="structural-engineer">Structural Engineer</option>
//                                     </select>
//                                 </div>

//                                 <div>
//                                     <label className="block text-gray-700 mb-2">Years of Experience <span className="text-red-500">*</span></label>
//                                     <input
//                                         type="number"
//                                         name="experience"
//                                         required
//                                         min="0"
//                                         max="50"
//                                         className="w-full p-2 border border-gray-300 rounded-lg"
//                                     />
//                                 </div>

//                                 <div>
//                                     <label className="block text-gray-700 mb-2">Cover Letter</label>
//                                     <textarea
//                                         name="coverLetter"
//                                         rows="4"
//                                         className="w-full p-2 border border-gray-300 rounded-lg"
//                                     />
//                                 </div>

//                                 <div>
//                                     <label className="block text-gray-700 mb-2">Upload Resume/CV (PDF-1MB Max Size) <span className="text-red-500">*</span></label>
//                                     <input
//                                         required
//                                         type="file"
//                                         name="resume"
//                                         accept=".pdf"
//                                         className="w-full p-2 border border-gray-300 rounded-lg"
//                                     />
//                                 </div>

//                                 <div className="mt-6 flex justify-center">
//                                     <button
//                                         type="submit"
//                                         className="rounded-lg w-full md:w-auto px-8 py-2 bg-gray-700 text-white hover:bg-gray-600"
//                                     >
//                                         Submit Application
//                                     </button>
//                                 </div>
//                             </form>
//                         </>
//                     ) : (
//                         <div className="p-8 text-center flex flex-col items-center justify-center">
//                             <div className="mb-6">
//                                 <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
//                                     <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
//                                     </svg>
//                                 </div>
//                                 <h2 className="text-2xl font-bold text-gray- 900 mb-2">Thank You for Reaching Out!</h2>
//                                 <p className="text-gray-600 text-sm">
//                                     We have received your request and appreciate you contacting us. Our team will get back to you shortly.
//                                 </p>
//                             </div>
//                             <button
//                                 onClick={redirectToHome}
//                                 className="bg-[#333333] text-white py-2 px-6 rounded-full hover:opacity-90 transition-colors"
//                             >
//                                 Close
//                             </button>
//                         </div>
//                     )}
//                 </div>

//                 <div>
//                     <h1 className="text-xl mb-4 text-gray-500">Explore</h1>
//                     <div className="flex-row space-y-4 mb-8">
//                         <div className="space-x-4">
//                             <Link to='/careers/early-careers'>
//                                 <button className="text-gray-600 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Early Careers</button>
//                             </Link>
//                             <Link to='/careers/benefits'>
//                                 <button className="text-gray-600 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Benefits</button>
//                             </Link>
//                         </div>
//                         <div>
//                             <Link to='/people/equity-diversity-and-inclusion'>
//                                 <button className="text-gray-600 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Equity, Diversity and Inclusion</button>
//                             </Link>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default Vacancies;